<template>
	<div :class="filterClass" class="filter filter--checkboxes">
		<dl class="filter__summary">
			<dt class="filter__summary__label" v-html="filterData.label"/>
			<dd v-if="filterValue" class="filter__summary__value" v-html="displayValue"/>
		</dl>
		<button v-if="filterValue" class="filter__clear" @click.prevent="clear()"><span>Clear filter</span>
		</button>
		<v-contextual-content ref="options" class="filter__options">
			<template v-slot:trigger="{ toggle }">
				<button v-if="!filterValue" class="filter__summary__set" @click.prevent="toggle()">
					<span>Show filter options</span></button>
				<button v-else class="filter__summary__clear" @click.prevent="toggle()"><span>Hide filter options</span>
				</button>
			</template>
			<h1 class="beta-up heavy">Filter by {{ filterData.label }}</h1>
			<div class="mt-2">
				<label v-for="(value, valueIndex) in filterData.values" :key="valueIndex" class="checkbox"><span
					v-html="value"/>
					<input v-model="form.data.status[valueIndex]" :value="true" type="checkbox">
				</label>
			</div>
			<ul class="actions actions--vertical">
				<li>
					<button
						class="button button--primary button--small button--wide" @click.prevent="apply()">Apply
					</button>
				</li>
				<li v-if="filterValue">
					<button
						class="button button--secondary button--small button--wide"
						@click.prevent="clear()">Clear filter
					</button>
				</li>
			</ul>
		</v-contextual-content>
	</div>
</template>
<script>
export default {
	data() {
		return {
			form: this.newForm({
				status: [],
			}),
			filterValue: null,
		};
	},

	computed: {
		filterClass() {
			return {
				"filter--has-filter": !!this.filterValue,
			};
		},
		displayValue() {
			if (!this.filterValue) {
				return null;
			}
			if (this.filterValue.length === 1) {
				return this.filterValue[0];
			}
			return this.$present("ntext", "# s", "# selected", this.filterValue.length);
		},
	},

	props: {
		filter: {
			required: true,
			type: Function,
		},
		filterData: {
			required: true,
			type: Object,
		},
	},

	methods: {
		apply() {
			this.setFilterValue();
			this.refs.options.toggle();
			this.filter(this.filterData.key, this.filterValue);
		},
		setFilterValue() {
			// console.log("setFilterValue", _.keys(_.pickBy(this.form.data.status, value => !!value)));
			let keys = _.keys(_.pickBy(this.form.data.status, value => !!value));
			this.filterValue = keys.length ? keys : null; // _.keys(_.pickBy(this.form.data.status, value => !!value));
		},
		clear() {
			this.filterValue = null;
			this.form.reset();
			this.filter(this.filterData.key, this.filterValue);
		},
	},

	created() {
		if (!this.filterData.value) {
			return;
		}
		let value = this.filterData.value ?? [];
		let obj = Object.keys(this.filterData.values).reduce((acc, curr) => {
			acc[curr] = value.indexOf(curr) > -1;
			return acc;
		}, {});
		this.form.set("status", obj);
		this.setFilterValue();
	},
};
</script>
